function useURL() {
    const local = process.env.REACT_APP_SELF_HOST;

    return { local }
}

export default useURL;